// src/AdminDashboard/components/MultiStepGameForm/steps/ContentStep.js
import React, { useState } from "react";

const ContentStep = ({ formData, updateFormData }) => {
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [editingTitle, setEditingTitle] = useState({}); // Track which titles are being edited

  const categories = Object.keys(formData.gameData);

  const handleCategoryTitleChange = (oldTitle, newTitle) => {
    // Don't update if the title is empty or hasn't actually changed
    if (!newTitle.trim() || oldTitle === newTitle) return;

    // Check if the new title already exists
    if (formData.gameData.hasOwnProperty(newTitle) && newTitle !== oldTitle) {
      return; // Don't allow duplicate category names
    }

    // Maintain the order by reconstructing the object with the new key in the same position
    const oldCategories = Object.keys(formData.gameData);
    const newGameData = {};

    oldCategories.forEach((categoryKey) => {
      if (categoryKey === oldTitle) {
        // Replace the old title with the new title but keep the same position
        newGameData[newTitle] = formData.gameData[oldTitle];
      } else {
        newGameData[categoryKey] = formData.gameData[categoryKey];
      }
    });

    updateFormData("gameData", newGameData);

    // Update expanded category if this one was expanded
    if (expandedCategory === oldTitle) {
      setExpandedCategory(newTitle);
    }
  };

  const handleTitleInputChange = (categoryTitle, newValue) => {
    // Track the current editing state
    setEditingTitle((prev) => ({
      ...prev,
      [categoryTitle]: newValue,
    }));
  };

  const handleTitleBlur = (categoryTitle) => {
    const newTitle = editingTitle[categoryTitle];
    if (newTitle !== undefined) {
      // Only update if there's a valid new title, otherwise revert
      if (newTitle.trim()) {
        handleCategoryTitleChange(categoryTitle, newTitle.trim());
      }
      // Clear the editing state
      setEditingTitle((prev) => {
        const updated = { ...prev };
        delete updated[categoryTitle];
        return updated;
      });
    }
  };

  const handleTitleKeyDown = (e, categoryTitle) => {
    if (e.key === "Enter") {
      e.target.blur(); // Trigger the blur event to save changes
    } else if (e.key === "Escape") {
      // Revert changes on escape
      setEditingTitle((prev) => {
        const updated = { ...prev };
        delete updated[categoryTitle];
        return updated;
      });
      e.target.blur();
    }
  };

  const handleCardChange = (categoryTitle, cardIndex, newValue) => {
    const newGameData = {
      ...formData.gameData,
      [categoryTitle]: formData.gameData[categoryTitle].map((card, index) =>
        index === cardIndex ? newValue : card
      ),
    };
    updateFormData("gameData", newGameData);
  };

  const toggleCategory = (categoryTitle) => {
    setExpandedCategory(
      expandedCategory === categoryTitle ? null : categoryTitle
    );
  };

  return (
    <div className="step-content">
      {categories.map((categoryTitle, categoryIndex) => (
        <div key={categoryTitle} className="category-section">
          <div
            className="category-header"
            onClick={() => toggleCategory(categoryTitle)}
          >
            <div className="category-title-group">
              <label>
                {categoryIndex === 0
                  ? "CATEGORY 1"
                  : categoryIndex === 1
                  ? "CATEGORY 2"
                  : categoryIndex === 2
                  ? "CATEGORY 3"
                  : "CATEGORY 4"}{" "}
                TITLE
              </label>
              <input
                type="text"
                value={
                  editingTitle[categoryTitle] !== undefined
                    ? editingTitle[categoryTitle]
                    : categoryTitle
                }
                onChange={(e) =>
                  handleTitleInputChange(categoryTitle, e.target.value)
                }
                onBlur={() => handleTitleBlur(categoryTitle)}
                onKeyDown={(e) => handleTitleKeyDown(e, categoryTitle)}
                onClick={(e) => e.stopPropagation()}
                placeholder={`Category ${categoryIndex + 1}`}
                className="category-title-input"
              />
            </div>
            <div className="expand-icon">
              {expandedCategory === categoryTitle ? "▼" : "▶"}
            </div>
          </div>

          {expandedCategory === categoryTitle && (
            <div className="category-cards">
              {formData.gameData[categoryTitle].map((card, cardIndex) => (
                <div key={cardIndex} className="card-input-group">
                  <label>CARD {cardIndex + 1}</label>
                  <input
                    type="text"
                    value={card}
                    onChange={(e) =>
                      handleCardChange(categoryTitle, cardIndex, e.target.value)
                    }
                    placeholder={`Card ${cardIndex + 1}`}
                    className="card-input"
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ContentStep;
